import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Target, Layers, Zap, Eye, RefreshCw } from "lucide-react";
import { motion } from "framer-motion";

const values = [
  {
    icon: Target,
    title: "Outcome-Driven",
    description: "We focus on measurable business results.",
  },
  {
    icon: Layers,
    title: "Systems Thinking",
    description: "We solve problems end-to-end, not in isolation.",
  },
  {
    icon: Zap,
    title: "Speed & Execution",
    description: "Fast response and action drive better outcomes.",
  },
  {
    icon: Eye,
    title: "Transparency",
    description: "Clear reporting and honest communication.",
  },
  {
    icon: RefreshCw,
    title: "Continuous Improvement",
    description: "We constantly test, learn, and optimize.",
  },
];

export const ValuesSection = () => {
  return (
    <section className="py-20 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-foreground">Our Values</h2>
          <p className="text-muted-foreground text-lg">The principles that guide everything we do</p>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {values.map((value, i) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
            >
              <Card className="h-full border-border bg-card hover:shadow-md transition-shadow text-center">
                <CardContent className="pt-7 pb-5">
                  <div className="inline-flex p-3 rounded-full bg-primary/10 mb-4">
                    <value.icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="font-semibold mb-2 text-foreground">{value.title}</h3>
                  <p className="text-sm text-muted-foreground">{value.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
